import React, { useEffect, useRef, useState } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import { useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import MenuPrimary from "../../menu/MenuPrimary";
import { useDispatch } from "react-redux";
import { setsearch, setDatePicker } from "../../../redux/features/dataSlice";
import { logEvent } from "../../../functions/amplitude";

const SearchBarPrimary = (props) => {
  const { placeholder, results, onFocus, customSearch, setCustomSearch } =
    props;
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const { search, academiaSearch } = useSelector((state) => state.data);

  const { pathname, search: filter } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const urlPath = location.pathname;

  const [list, setlist] = useState(search ? results : []);
  const [listVisible, setlistVisible] = useState(false);

  const parts = pathname.split("/"); // Split the URL into an array of parts
  parts.pop(); // Remove the last part (i.e. "searchterm")
  const categoryUrl = parts.join("/"); // Join the remaining parts back into a string

  const listRef = useRef(null);

  useEffect(() => {
    if (search) {
      const newList = results.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      setlist(newList);
    } else {
      setlist([]);
    }
  }, [search, results]);

  useEffect(() => {
    if (search) {
      setlistVisible(true);
    } else {
      setlistVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    const pathname = location.pathname;
    const parts = pathname.split("/");
    const Param = parts[parts.length - 1];

    const decodedParam = Param ? decodeURIComponent(Param) : "";

    if (pathname.includes("/books/")) {
      dispatch(setsearch(decodedParam || "usa"));
    } else if (pathname.includes("/wiki/")) {
      dispatch(setsearch(decodedParam || "usa"));
    }
  }, [location]);

  useOnClickOutside(listRef, () => setlistVisible(false));

  function onSearch(query) {
    const encodedQuery = encodeURIComponent(query);
    dispatch(setsearch(query));
    if (pathname.includes("/books/")) {
      encodedQuery
        ? navigate(`books/${encodedQuery}${filter}`)
        : navigate(`books/usa`);
    } else if (pathname.includes("/category/")) {
      navigate(`${categoryUrl}/${encodedQuery}${filter}`);
    } else if (pathname.includes("/wiki/")) {
      encodedQuery
        ? navigate(`wiki/${encodedQuery}${filter}`)
        : navigate(`wiki/usa`);
    } else {
      navigate(`/search/${encodedQuery}${filter}`);
    }
    setlistVisible(false);
  }

  function redirectDate(filter) {
    const encodedQuery = encodeURIComponent(customSearch);

    if (pathname.includes("category/")) {
      navigate(`${categoryUrl}/${encodedQuery}?filter=${filter}`);
    } else {
      navigate(`search/${encodedQuery}?filter=${filter}`);
    }
    dispatch(setsearch(customSearch));

    logEvent("submit_navbar_search", { searchquery: customSearch });
  }

  const handleInputChange = (e) => {
    setCustomSearch(e.target.value);
  };

  const checkIsFilterAVailable = () => {
    const part1 = urlPath.includes("/books/") || urlPath.includes("/wiki/");
    const part2 =
      urlPath.includes("/category/Academia") && academiaSearch !== "Academia";
    return part1 || part2;
  };

  useEffect(() => {
    setCustomSearch(search);
  }, [search]);

  return (
    <div className="search-bar-primary">
      <input
        type="text"
        placeholder={placeholder}
        value={customSearch}
        onChange={handleInputChange}
        onFocus={() => {
          setlistVisible(true);
          onFocus && onFocus();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSearch(customSearch);
            logEvent("submit_navbar_search", { searchquery: customSearch });
          }
        }}
      />
      {!checkIsFilterAVailable() && (
        <MenuPrimary
          label=""
          data={[
            {
              name: "Past 24 hours",
              onClick: () => redirectDate("Past 24 hours"),
            },
            {
              name: "Past Week",
              onClick: () => redirectDate("Past Week"),
            },
            {
              name: "Past Month",
              onClick: () => redirectDate("Past Month"),
            },
            {
              name: "Past Year",
              onClick: () => redirectDate("Past Year"),
            },
            {
              name: "Past 2 Years",
              onClick: () => redirectDate("Past 2 Years"),
            },
            {
              name: "Past 3 years",
              onClick: () => redirectDate("Past 3 years"),
            },
            {
              name: "All time",
              onClick: () => redirectDate("All time"),
            },
            {
              name: "Custom Date",
              onClick: () => {
                dispatch(setDatePicker(true));
              },
            },
          ]}
          className="menu-select"
          children={
            <div className="select">
              <p>
                {searchParams.get("filter")
                  ? searchParams.get("filter")
                  : "All time"}
              </p>
              <KeyboardArrowDownRoundedIcon />
            </div>
          }
        />
      )}

      {list.length && listVisible ? (
        <div className="list" ref={listRef}>
          {list.map((item, i) => (
            <div
              key={i}
              className="item"
              onClick={() => {
                onSearch(item.name);
              }}
            >
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      ) : null}
      <div
        className="btn"
        onClick={() => {
          onSearch(customSearch);
        }}
      >
        <SearchRoundedIcon />
      </div>
    </div>
  );
};

export default SearchBarPrimary;
